export default {
    cheatsheet: {
        title: "Cheatsheet",
        empty: {
            noPlaysAvailable: "No plays available",
        },
        separators: {
            noLongerPerfect: "No longer 100% below this",
        },
        generate: {
            homeRow: "Generate your cheatsheet",
            results: {
                title: "Your Cheatsheet",
                subtitle: "Generated",
            },
            actions: {
                generate: "Generate",
            },
            options: {
                all: "All",
            },
            empty: {
                title: "No props found",
                subtitle: "Try changing your selections to find more props.",
                action: "Adjust selections",
            },
            outcome: {
                title: "What are you looking for?",
                subtitle: "Choose Over or Under.",
                over: "Over",
                under: "Under",
            },
            propType: {
                title: "What do you prefer?",
                subtitle: "Choose player or team props.",
                player: "Player Props",
                team: "Team Props",
            },
            lineType: {
                title: "Which lines do you want?",
                subtitle: "Choose Main or Alternate.",
                main: "Main Lines",
                alternate: "Alternate Lines",
            },
            cheatsheetType: {
                title: "What should we base it on?",
                subtitle: "Choose which timeframe to base it on.",
                recentForm: "Recent Form",
                versusOpponent: "Versus Opponent",
                homeAwaySplits: "Home/Away Splits",
            },
            games: {
                title: "Which games to include?",
                subtitle: "Include every game or pick the ones you want.",
            },
            betTypes: {
                title: "Which props do you want?",
                subtitle: "Choose the bet types you want to include.",
            },
            operators: {
                title: "Where should we look?",
                subtitle: "Choose the odds you want to include.",
            },
            loader: {
                prefix: "Looking at",
                ready: "Cheatsheet ready",
                accessibilityLabel: "Generating your cheatsheet",
                values: {
                    overs: "Overs...",
                    unders: "Unders...",
                    mainLines: "Main Lines...",
                    alternateLines: "Alternate Lines...",
                    recentForm: "Recent Form...",
                    versusOpponent: "Versus Opponent...",
                    homeAwaySplits: "Home/Away Splits...",
                    todaysGames: "Today's games...",
                    selectedGames: "{{count}} selected game(s)...",
                    allBetTypes: "All bet types...",
                    oneBetType: "{{name}}...",
                    twoBetTypes: "{{first}} & {{second}}...",
                    manyBetTypes: "{{count}} bet types...",
                    yourSportsbooks: "Your sportsbooks...",
                    allSportsbooks: "All sportsbooks...",
                    specificSportsbooks: "{{count}} sportsbook(s)...",
                    building: "Building your Cheatsheet...",
                },
            },
        },
    },
};
